/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundPictureDetailGoodsInfoVo
 */
export interface InboundPictureDetailGoodsInfoVo {
    /**
     * 商品id
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    goodsId?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    orderCode?: string;
    /**
     * 接收人
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    receiver?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    goodsCode?: number;
    /**
     * 商品图片
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    goodsImg?: string;
    /**
     * 颜色颜色
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    size?: string;
    /**
     * 数量
     * @type {number}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    quantity?: number;
    /**
     * 商品状态
     * @type {string}
     * @memberof InboundPictureDetailGoodsInfoVo
     */
    goodsStatusName?: string;
}

/**
 * Check if a given object implements the InboundPictureDetailGoodsInfoVo interface.
 */
export function instanceOfInboundPictureDetailGoodsInfoVo(value: object): value is InboundPictureDetailGoodsInfoVo {
    return true;
}

export function InboundPictureDetailGoodsInfoVoFromJSON(json: any): InboundPictureDetailGoodsInfoVo {
    return InboundPictureDetailGoodsInfoVoFromJSONTyped(json, false);
}

export function InboundPictureDetailGoodsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundPictureDetailGoodsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsImg': json['goodsImg'] == null ? undefined : json['goodsImg'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
    };
}

export function InboundPictureDetailGoodsInfoVoToJSON(json: any): InboundPictureDetailGoodsInfoVo {
    return InboundPictureDetailGoodsInfoVoToJSONTyped(json, false);
}

export function InboundPictureDetailGoodsInfoVoToJSONTyped(value?: InboundPictureDetailGoodsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'orderCode': value['orderCode'],
        'receiver': value['receiver'],
        'goodsCode': value['goodsCode'],
        'goodsImg': value['goodsImg'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'goodsStatusName': value['goodsStatusName'],
    };
}

